export function setObject(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
export function getObject(key) {
    const value = localStorage.getItem(key);
    return value && JSON.parse(value);
}
